import { useTheme } from "@mui/material/styles";
import {
    Avatar,
    Box,
    Chip,
    ClickAwayListener,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Typography,
    useMediaQuery,
} from "@mui/material";

import MainCard from "components/common/card/MainCard";
import Transitions from "components/extended/Transitions";

import { IconLogout, IconSettings } from "@tabler/icons";
import useConfig from "hooks/useConfig";
import { useTranslation } from "react-i18next";

const ProfileComponent = ({
    user,
    open,
    selectedIndex,
    handleToggle = () => { },
    handleLogout = () => { },
    handleClose = () => { },
    handleListItemClick = () => { },
    anchorRef,
    children
}) => {
    const { t } = useTranslation()
    const theme = useTheme();
    const { borderRadius } = useConfig();
    const matchMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <>
            <Chip
                sx={{
                    height: matchMobile ? 35 : "48px",
                    alignItems: "center",
                    borderRadius: "27px",
                    transition: "all .2s ease-in-out",
                    borderColor: matchMobile ? 'transparent' :
                        theme.palette.mode === "dark"
                            ? theme.palette.dark.main
                            : theme.palette.primary.light,
                    "& .MuiChip-label": {
                        lineHeight: 0,

                    },
                }}
                icon={
                    <IconButton
                        onClick={handleToggle}
                        sx={{
                            padding: 0,
                            "&:hover": {
                                backgroundColor: "transparent",
                            },

                        }}
                    >
                        <Avatar
                            sx={{
                                ...theme.typography.mediumAvatar,
                                margin: "8px 0 8px 8px !important",
                                cursor: "pointer",
                            }}
                            ref={anchorRef}
                            aria-controls={open ? "menu-list-grow" : undefined}
                            aria-haspopup="true"
                            color="inherit"
                        />
                    </IconButton>
                }
                label={
                    children
                }
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? "menu-list-grow" : undefined}
                aria-haspopup="true"
                // onClick={handleToggle}
                color="primary"
            />

            <Popper
                placement="bottom"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 14],
                            },
                        },
                    ],
                }}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Transitions in={open} {...TransitionProps}>
                            <Paper>
                                {open && (
                                    <MainCard
                                        border={false}
                                        elevation={16}
                                        content={false}
                                        boxShadow
                                        shadow={theme.shadows[16]}
                                    >
                                        <Box sx={{ p: 2, pb: 0 }}>
                                            <Stack>
                                                <Stack
                                                    direction="row"
                                                    spacing={0.5}
                                                    alignItems="center"
                                                >
                                                    <Typography variant="h4">{t('Welcome')}</Typography>
                                                    <Typography
                                                        component="span"
                                                        variant="h4"
                                                        sx={{ fontWeight: 400 }}
                                                    >
                                                        {user?.firstName}
                                                    </Typography>
                                                </Stack>
                                                <Typography variant="subtitle2">
                                                    {`${t('Role')}: ${user?.role}`}
                                                </Typography>
                                            </Stack>
                                        </Box>

                                        <Box sx={{ p: 2, pt: 0 }}>
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: "100%",
                                                    maxWidth: 300,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: "10px",
                                                    [theme.breakpoints.down("md")]: {
                                                        minWidth: "100%",
                                                    },
                                                    "& .MuiListItemButton-root": {
                                                        mt: 0.5,
                                                    },
                                                }}
                                            >
                                                {/*<ListItemButton TODO: SOLO DEMO*/}
                                                {/*    sx={{ borderRadius: `${borderRadius}px` }}*/}
                                                {/*    selected={selectedIndex === 0}*/}
                                                {/*    onClick={(event) =>*/}
                                                {/*        handleListItemClick(*/}
                                                {/*            event,*/}
                                                {/*            0,*/}
                                                {/*            "/dashboard/profile/settings"*/}
                                                {/*        )*/}
                                                {/*    }*/}
                                                {/*>*/}
                                                {/*    <ListItemIcon>*/}
                                                {/*        <IconSettings stroke={1.5} size="20px" />*/}
                                                {/*    </ListItemIcon>*/}
                                                {/*    <ListItemText*/}
                                                {/*        primary={*/}
                                                {/*            <Typography variant="body2">*/}
                                                {/*                {t('Account settings')}*/}
                                                {/*            </Typography>*/}
                                                {/*        }*/}
                                                {/*    />*/}
                                                {/*</ListItemButton>*/}

                                                <ListItemButton
                                                    sx={{ borderRadius: `${borderRadius}px` }}
                                                    selected={selectedIndex === 4}
                                                    onClick={handleLogout}
                                                >
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="20px" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2">Logout</Typography>
                                                        }
                                                    />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </MainCard>
                                )}
                            </Paper>
                        </Transitions>
                    </ClickAwayListener>
                )}
            </Popper>
        </>
    );
};

export default ProfileComponent;
